module.exports = __webpack_public_path__ + "img/20.e7b5122d.svg";